const formValidate = {
    methods: {
        // 子组件的校验方法
        async justify() {
            try {
                return await this.$refs['form'].validate()
            }
            catch (error) {
                return false
            }
        },
        clearValidate() {
            this.$refs.form.resetFields();
        }
    }
}

export default formValidate;